import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function LogsHeader(props) { return ( <ContentHeader title="System's Logs" />) }

export default React.memo(LogsHeader)
